export const ACTION_CONSTS = {
  ADD_INFERENCE_STATUS: 'ADD_INFERENCE_STATUS',
};

export const INFERENCE_STATUS_EVENT_ID = 'onStateChange_inference_status_231d2';

export const INFERENCE_STATUS_EVENT = new Event(INFERENCE_STATUS_EVENT_ID);
